import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useContainerOptions(refresh) {
  const authContext = useContext(AuthContext);

  const [containerOptions, setContainerOptions] = useState([]);

  const getContainerOptions = async () => {
    const response = await fetchWithInterceptor(
      "/api/container-options?isActive=true&limit=1000",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      }
    );

    if (!response?.ok) return;

    const data = await response.json();
    const rows = Array.isArray(data.rows) ? data.rows : [];

    setContainerOptions(
      rows.map((option) => ({
        label: option.name,
        value: option.name,
      }))
    );
  };

  useEffect(() => {
    getContainerOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return containerOptions;
}

